import axios from 'axios';
import { constants } from '../../Helpers/constantsFile';

/**
 * Stations — the kitchen, the bar, the coffee counter.
 *
 * A station is a cost centre, not a printer and not a menu category. It is the
 * single tag the revenue side and the cost side both point at, which is what
 * makes "the kitchen sold 100 and spent 50" a question with an answer. The
 * model says it out loud: it carries no printer, because rerouting a ticket is
 * an operations decision and must never move money between cost centres.
 *
 * Stock is the reason this screen exists: issuing stock with the Usage reason
 * requires a station, and until now there was nowhere on the till to add one.
 *
 * Reading is open to manager, storekeeper and accountant; writing is manager,
 * storekeeper and superadmin.
 */

const auth = (token) => ({ headers: { authorization: token } });

export async function fetchStations({ businessId, token }) {
  const { data } = await axios.get(
    `${constants.baseUrl}/stations/get-business-stations/${businessId}`,
    auth(token)
  );
  return data?.data?.stations || [];
}

export async function createStation({ payload, token }) {
  const { data } = await axios.post(`${constants.baseUrl}/stations`, payload, auth(token));
  return data?.data?.createdStation;
}

export async function updateStation({ id, payload, token }) {
  const { data } = await axios.patch(
    `${constants.baseUrl}/stations/${id}`,
    payload,
    auth(token)
  );
  return data?.data?.updatedStation;
}

/**
 * A station is RETIRED, not deleted.
 *
 * The server sets `isActive` false and says so in its message: expenses, stock
 * movements and order items already point at it, and removing the row would
 * leave last quarter's report unable to say where the money went. The answer
 * still comes back under `deletedStation`, which is the server's own wording
 * for a row that is still very much there.
 */
export async function deleteStation({ id, token }) {
  const { data } = await axios.delete(`${constants.baseUrl}/stations/${id}`, auth(token));
  return {
    station: data?.data?.deletedStation || null,
    message: data?.message || '',
  };
}
